export enum PickerColors {
  green = 'green',
  orange = 'orange'
}
